import styles from "./downBtn.module.scss";
import Link from "next/link";
import { mmgaevent, mmgaevent1 } from "../../utils/ga";
import utils from "../../utils";
import useDownLoad from "../../hooks/useDownLoad";
import { useRouter } from "next/router";
export default function DownBtn(props) {
  const router = useRouter();
  const routerName = router.pathname;
  const { iosLink, andLink } = useDownLoad();

  const icon = () => {
    if (props.use === "mb") {
      return {
        ios: "/images/download/appstore_big@2x (1).png",
        google: "/images/download/googleplay_big@2x (1).png",
      };
    } else if (props.use === "big") {
      return {
        google: "/img/googleplay-b.png",
        ios: "/img/appstore-b.png",
      };
    } else {
      return {
        google: "/img/googleplay-s.png",
        ios: "/img/appstore-s.png",
      };
    }
  };

  function handlePost(type) {
    if (!utils.IsPC()) {
      if (type === 1) {
        mmgaevent(
          "Botton_click",
          routerName === "/" ? "Top_IOS_button" : "IOS_button"
        );
      } else if (type === 2) {
        mmgaevent(
          "Botton_click",
          routerName === "/" ? "Top_And_button" : "And_button"
        );
      }
    }
  }
  return (
    <div
      className={
        styles.down +
        " " +
        (props.ani ? " ani-fadeInUp" : "") +
        " " +
        (props.use === "mb" ? styles.mb : "")
      }
    >
      <Link href={String(iosLink)} target="_blank" rel="noreferrer">
        <a target="_blank" rel="" onClick={() => handlePost(1)}>
          <img src={icon().ios} alt="appstore" />
        </a>
      </Link>
      <Link href={String(andLink)} target="_blank" rel="noreferrer">
        <a target="_blank" rel="" onClick={() => handlePost(2)}>
          <img src={icon().google} alt="googleplay" />
        </a>
      </Link>
    </div>
  );
}
